import { Dispatch } from 'react';
import {
  GET_PRODUCT_LIST, GET_PRODUCT, POST_PRODUCT, DELETE_PRODUCT, PUT_PRODUCT, UPDATE_PRODUCT_FILTERS
} from '../types/product.types';
import { CoreApi } from '../../../api/api.apiclient';
import { ProductFilters, ProductRequest } from '../../../api/core/core.types';
import { PageRequest } from '../../../api/api.types';

export const getProductList = (filters?: ProductFilters, pageRequest?: PageRequest, isDeletedIncluded?: boolean) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Products.listAllProducts(filters, pageRequest, isDeletedIncluded);

  dispatch({
    type: GET_PRODUCT_LIST,
    payload: {
      page: response.data,
      totalElements: response.data.totalElements,
      totalPages: response.data.totalPages
    }
  });

  return Promise.resolve();
};

export const getProduct = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.Products.getOneProduct(id);

    dispatch({
      type: GET_PRODUCT,
      payload: {
        selectedProduct: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_PRODUCT,
      payload: {
        selectedProduct: null
      }
    });
  }
};

export const addNewProduct = (request: ProductRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Products.addNewProduct(request);

  dispatch({
    type: POST_PRODUCT,
    payload: {
      success: true,
      newProduct: response.data
    }
  });
};

export const deleteProduct = (id: number) => async (dispatch: Dispatch<any>) => {
  await CoreApi.Products.deleteProduct(id);
  dispatch({
    type: DELETE_PRODUCT,
    payload: {
      success: true
    }
  });
};

export const editProduct = (id: number, request: ProductRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Products.editProduct(id, request);

  dispatch({
    type: PUT_PRODUCT,
    payload: {
      selectedProduct: response.data
    }
  });
};

export const updateProductFilters = (filters: ProductFilters | null) => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: UPDATE_PRODUCT_FILTERS,
    payload: {
      filters
    }
  });
};
